import { TranslationMap } from '@trimble-gcs/i18n-types';

export function modusOptionListTranslations() {
  return {
    optionList: {
      noResultsFound: {
        text: $localize`:@@modusOptionList.noResultsFound:No results found`,
        desc:
          'Message displayed in the option list of an autocomplete control ' +
          'when none of the available options match the user input.',
      },
      noResultsFoundHint: {
        text: $localize`:@@modusOptionList.noResultsFoundHint:Try a different search`,
        desc:
          'Sub-text displayed in the option list of an autocomplete control ' +
          'when none of the available options match the user input. ' +
          'The text is displayed in a smaller font, below the "No results found" message.',
      },
    },
  } satisfies TranslationMap;
}
